import { useContext } from 'react';
import { ThemeContext, ThemeSkinContext, } from '@wix/da-react-context/pkg/ThemeContext';
import { getDefaultAvatarSrc, getUserAvatarSrc } from '../../User/helpers';
/** @deprecated */
export function useAvatarSrc(user) {
    var _a;
    var theme = useContext(ThemeContext);
    var themeSkin = useContext(ThemeSkinContext);
    return (_a = getUserAvatarSrc(user)) !== null && _a !== void 0 ? _a : getDefaultAvatarSrc(theme, themeSkin);
}
//# sourceMappingURL=useAvatarSrc.js.map